export const EVENT_ACTION = {
    RESET_EVENTS_LIST_STATE : "RESET_EVENTS_LIST_STATE",
    REQUEST_EVENTS_LIST : "REQUEST_EVENTS_LIST",
    RESPONSE_EVENTS_LIST : "RESPONSE_EVENTS_LIST",
    ERROR_EVENTS_LIST : "ERROR_EVENTS_LIST",

    RESET_WORKANNIVERSARY_WISHES_STATE: "RESET_WORKANNIVERSARY_WISHES_STATE",
    REQUEST_WORK_ANNIVERSARY_WISHES: "REQUEST_WORK_ANNIVERSARY_WISHES",
    RESPONSE_WORK_ANNIVERSARY_WISHES: "RESPONSE_WORK_ANNIVERSARY_WISHES",
    ERROR_WORK_ANNIVERSARY_WISHES: "ERROR_WORK_ANNIVERSARY_WISHES",

    RESET_BIRTHDAY_WISHES_STATE: "RESET_BIRTHDAY_WISHES_STATE",
    REQUEST_BIRTHDAY_WISHES: "REQUEST_BIRTHDAY_WISHES",
    RESPONSE_BIRTHDAY_WISHES: "RESPONSE_BIRTHDAY_WISHES",
    ERROR_BIRTHDAY_WISHES: "ERROR_BIRTHDAY_WISHES",

    RESET_EVENTS_NOTIFICATIONS_LIST_STATE : "RESET_EVENTS_NOTIFICATIONS_LIST_STATE",
    REQUEST_EVENTS_NOTIFICATIONS_LIST : "REQUEST_EVENTS_NOTIFICATIONS_LIST",
    RESPONSE_EVENTS_NOTIFICATIONS_LIST : "RESPONSE_EVENTS_NOTIFICATIONS_LIST",
    ERROR_EVENTS_NOTIFICATIONS_LIST : "ERROR_EVENTS_NOTIFICATIONS_LIST",
};

export const setResetStateWorkAnniversaryWishes = () => ({
    type: EVENT_ACTION.RESET_WORKANNIVERSARY_WISHES_STATE,
    data: undefined
})

export const requestWorkAnniversaryWishes = (params) => ({
    type: EVENT_ACTION.REQUEST_WORK_ANNIVERSARY_WISHES,
    data: params
})
export const responseWorkAnniversaryWishes = (res) => ({
    type: EVENT_ACTION.RESPONSE_WORK_ANNIVERSARY_WISHES,
    data: res
})
export const errorWorkAnniversaryWishes = (err) => ({
    type: EVENT_ACTION.ERROR_WORK_ANNIVERSARY_WISHES,
    data: err
  });


  export const setResetStateBirthdayWishes = () => ({
    type: EVENT_ACTION.RESET_BIRTHDAY_WISHES_STATE,
    data: undefined
})

export const requestBirthdayWishes = (params) => ({
    type: EVENT_ACTION.REQUEST_BIRTHDAY_WISHES,
    data: params
})
export const responseBirthdayWishes = (res) => ({
    type: EVENT_ACTION.RESPONSE_BIRTHDAY_WISHES,
    data: res
})
export const errorBirthdayWishes = (err) => ({
    type: EVENT_ACTION.ERROR_BIRTHDAY_WISHES,
    data: err
  });


export const setResetStateEvents = () => ({
    type: EVENT_ACTION.RESET_EVENTS_LIST_STATE,
    data: undefined
})

export const requestEventsAction = (params) => ({
    type: EVENT_ACTION.REQUEST_EVENTS_LIST,
    data: params
})
export const responseEventsAction = (res) => ({
    type: EVENT_ACTION.RESPONSE_EVENTS_LIST,
    data: res
})
export const errorEventsAction = (err) => ({
    type: EVENT_ACTION.ERROR_EVENTS_LIST,
    data: err
  });

  export const setResetStateEventsNotifications = () => ({
    type: EVENT_ACTION.RESET_EVENTS_NOTIFICATIONS_LIST_STATE,
    data: undefined
})

export const requestEventsNotificationsAction = (params) => ({
    type: EVENT_ACTION.REQUEST_EVENTS_NOTIFICATIONS_LIST,
    data: params
})
export const responseEventsNotificationsAction = (res) => ({
    type: EVENT_ACTION.RESPONSE_EVENTS_NOTIFICATIONS_LIST,
    data: res
})
export const errorEventsNotificationsAction = (err) => ({
    type: EVENT_ACTION.ERROR_EVENTS_NOTIFICATIONS_LIST,
    data: err
  });

